/**
 * The HTTP path Socket.IO handshakes on.
 *
 * Not the library default (`/socket.io`) because the ALB routes to each API by
 * path prefix, and the realtime endpoint has to be a rule the load balancer can
 * name. Shared with the clients so the two cannot drift — a mismatched path
 * fails as a 404 on the handshake, which surfaces as "connecting…" forever
 * rather than as an error anyone would notice.
 */
export const REALTIME_PATH = '/realtime';
